import { InlineSvg } from 'components/svg';
import { FC } from 'react';

type NewContactIframeModalHeaderProps = {
  onClose: () => void;
};

export const NewContactIframeModalHeader: FC<NewContactIframeModalHeaderProps> = ({ onClose }) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <div style={{ width: '100%' }} className="text-center">
        <h2 className="fw-bolder">Contact Dialog</h2>
      </div>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-maintenance-task-action="close"
        onClick={() => onClose()}
        style={{ cursor: 'pointer' }}
      >
        <InlineSvg path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};
